import { render, staticRenderFns } from "./CargoNew.vue?vue&type=template&id=9579be0c&scoped=true&"
import script from "./CargoNew.vue?vue&type=script&lang=js&"
export * from "./CargoNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9579be0c",
  null
  
)

export default component.exports